export default {
	'the-subscripter': 'the subscripter?'
}